// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__-AtH5","colMaxWidth":"Table_colMaxWidth__1wo5Z"};